import axios from 'axios';
import SelectiveProcessFilter from '../selective-process-filter.entity';
import Department from '../entity/job/department.entity';
import CandidateResult from '../entity/candidate/candidate-result.entity';
import Candidate from '../entity/candidate/candidate.entity';
import CandidateResetSurveyHistory from '../entity/candidate/candidate-reset-survey-history.entity';

export default class SelectiveProcessService {
  public static findAssessments(
    filter: SelectiveProcessFilter,
    page: number,
    size: number,
    sortBy: string,
  ) {
    return axios.get('/api/selective-process', {
      params: {
        job: filter.hasJobs ? filter.jobs : null,
        candidatesEmails: filter.hasCandidatesEmails ? filter.candidatesEmails : null,
        candidateName: filter.hasCandidateName ? filter.candidateName : null,
        cultureGrade: filter.hasCultureGrade ? parseFloat(filter.cultureGrade) : null,
        cultureGradePeriodStart: filter.hasCultureGradePeriod
          ? filter.cultureGradePeriod[0] : null,
        cultureGradePeriodEnd: filter.hasCultureGradePeriod
          ? filter.cultureGradePeriod[1] : null,
        jobApplicationStatus: filter.hasJobStatus ? filter.jobStatus.toString() : null,
        numericalReasoningGradePercentage: filter.numericalReasoningGradePercentage || null,
        numericalReasoningGradePeriodStart: filter.numericalReasoningGradePeriod[0] || null,
        numericalReasoningGradePeriodEnd: filter.numericalReasoningGradePeriod[1] || null,
        verbalReasoningGradePercentage: filter.verbalReasoningGradePercentage || null,
        verbalReasoningGradePeriodStart: filter.verbalReasoningGradePeriod[0] || null,
        verbalReasoningGradePeriodEnd: filter.verbalReasoningGradePeriod[1] || null,
        page: page - 1,
        size,
        orderBy: sortBy,
      },
    });
  }

  public static getCultureGradeDetails(
    listCandidateID: string[],
  ) {
    return axios.get('/api/selective-process/cultureGradeDetails', {
      params: {
        candidates: listCandidateID.toString(),
      },
    });
  }

  public static getCandidateCultureGradeDetails(candidateId: string) {
    return axios.get(`/api/selective-process/candidate/${candidateId}/cultureGradeDetails`);
  }

  public static getDetailsReport(page: number, size: number) {
    return axios.get('/api/selective-process/details/report', {
      params: {
        page: page - 1,
        size,
      },
    })
  }

  public static async findAllDepartment(): Promise<Department[]> {
    return axios.get('/api/selective-process/jobs/departments')
      .then(({ data }) => data.map(it => new Department(it)));
  }

  public static async updateDepartmentThreshold({ id, threshold }) {
    return axios
      .patch(`/api/selective-process/jobs/departments/${id}/threshold`, { threshold })
  }

  public static async importAllDepartment() {
    return axios.post('/api/pinpoint/department/integrate-all');
  }

  public static async getPersonalityResult(
    candidateId: string,
  ): Promise<CandidateResult> {
    return axios.get(`/api/selective-process/candidate/${candidateId}/result`)
      .then(({ data }) => data)
  }

  public static async getCandidateById(candidateId: string): Promise<Candidate> {
    return axios.get(`/api/candidate/${candidateId}`)
      .then(({ data }) => new Candidate(data));
  }

  public static async forceImportCandidate(jobId: string, candidateId: string) {
    return axios.post(`/api/selective-process/import/${jobId}/candidate/${candidateId}`);
  }

  public static async getAllStatus(): Promise<string[]> {
    return axios.get('/api/selective-process/status')
      .then(({ data }) => data);
  }

  public static async reset(surveyAnswerId: string, reason: string) {
    return axios.post(`/api/selective-process/${surveyAnswerId}/reset-survey-answer`, { reason });
  }

  public static async getResetHistory(
    candidateAssessmentId: string,
  ): Promise<CandidateResetSurveyHistory[]> {
    return axios.get(`/api/selective-process/${candidateAssessmentId}/reset-survey-history`)
      .then(({ data }) => data.map(item => new CandidateResetSurveyHistory(item)));
  }
}
